import React from "react"
import Editor from "./Editor"

const Component = ({ explorer, param }) => <Editor explorer={explorer} param={param} />

export default Component
